export enum ConversationActionType {
    SetTeamsContext = 'conversation.SET_TEAMS_CONTEXT',
    SetChatMembers = 'conversation.SET_CHAT_MEMBERS',
    SetIsExternalMember = 'conversation.SET_IS_EXTERNAL_MEMBER',
    SetShareContext = 'conversation.SET_SHARE_CONTEXT',
    SetUserIdsResponse = 'conversation.SET_USER_IDS_RESPONSE',
    SetTeamMember = 'conversation.SET_TEAM_MEMBER',
    SetMemberResolution = 'conversation.SET_MEMBER_RESOLUTION',
}
